export default "__VITE_ASSET__C_eTog$A__"